export const menu = {
  organization: [
    "General",
    // "Email",
    "Rates",
    "Dispatch",
    // "Templates",
    // "Task Templates",
    "Tags",
    // "Notification Templates",
    // "Advanced",
    // "Job",
    // "Teams",
    "Users",
    "Roles Permissions",
    "Billing",
    "Reports",
    "Google Drive",
    // "Feedback",
    // "Naming Conventions",
    // "History",
    // "Features",
  ],
};
